import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Typography
} from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'
import { FiCheckCircle, FiAlertTriangle, FiAlertCircle } from 'react-icons/fi'

export const NotificationModal = ({
  message,
  title,
  iconType,
  returnPath,
  setBackStateFunction,
  size,
  bodyClassName,
  children
}) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(true)

  const handleOpen = () => {
    setOpen(!open)
    if (returnPath) navigate(generatePath(returnPath))
    if (setBackStateFunction) setBackStateFunction(false)
  }

  const icons = {
    check: (
      <div className='w-16 h-16 bg-green-50 border-green-50 p-3 rounded-[28px] text-green-700'>
        <div className='bg-green-100 rounded-[28px] p-3 w-10 h-10  relative flex-col justify-start items-start flex'>
          <FiCheckCircle
            size='1.5rem'
            className='absolute m-auto top-0 bottom-0 left-0 right-0'
          />
        </div>
      </div>
    ),
    danger: (
      <div className='w-16 h-16 bg-amber-50 border-amber-50 p-3 rounded-[28px] text-amber-900'>
        <div className='bg-amber-100 rounded-[28px] p-3 w-10 h-10  relative flex-col justify-start items-start flex'>
          <FiAlertTriangle
            size='1.5rem'
            className='absolute m-auto top-0 bottom-0 left-0 right-0'
          />
        </div>
      </div>
    ),
    error: (
      <div className='w-16 h-16 bg-red-50 border-red-50 p-3 rounded-[28px] text-red-700'>
        <div className='bg-red-100 rounded-[28px] p-3 w-10 h-10  relative flex-col justify-start items-start flex'>
          <FiAlertCircle
            size='1.5rem'
            className='absolute m-auto top-0 bottom-0 left-0 right-0'
          />
        </div>
      </div>
    )
  }

  return (
    <Dialog open={open} size={size} className='p-3'>
      <DialogHeader className='pb-0'>{icons[iconType]}</DialogHeader>
      <div className='flex flex-col gap-3'>
        <DialogBody className={bodyClassName}>
          <Typography variant='h6' className='text-black text-lg'>
            {title}
          </Typography>
          <Typography className='mt-3' variant='small'>
            {message}
          </Typography>
          {children}
        </DialogBody>
        <DialogFooter>
          <Button
            fullWidth
            color='blue'
            onClick={handleOpen}
            size='lg'
            className='normal-case'
          >
            Aceptar
          </Button>
        </DialogFooter>
      </div>
    </Dialog>
  )
}

NotificationModal.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  iconType: PropTypes.string,
  setBackStateFunction: PropTypes.func,
  returnPath: PropTypes.string,
  size: PropTypes.string,
  bodyClassName: PropTypes.string
}

NotificationModal.defaultProps = {
  open: false,
  size: 'sm',
  bodyClassName: ''
}
